module.exports = __webpack_public_path__ + "img/5.52bc7207.jpg";